import React from "react";
import "./Loading.css";
import loaderImg from "../../../assets/img/llt-icon.png";

const Loading = () => {
  return (
    <div className="Loader">
    <div className="loading-overlay">
      <div className="loading-icon">
        <div className="spinner"></div>
      </div>
      <img src={loaderImg} alt="Logo"width="60" height="60" className="img-logo" />
    </div>
    </div>
  );
};

export default Loading;

